<template>
  <div class="profile-dropdown">
    <v-select
      :multiple="true"
      v-model="currentItems"
      :items="selectableItems"
      :style="fullwidth ? 'width: 100%' : $vuetify.breakpoint.mdAndUp ? 'width: 50%' : 'width: 80%'"
      single-line
      item-color="primary"
      :append-icon="'fxt-chevron-down'"
      @change="changedValue"
    >
      <template v-slot:selection="{ item }">
        <span class="profile-dropdown__selected mr-1">{{ item + (currentItems.length > 1 && currentItems[currentItems.length - 1] !== item ? ', ' : '') }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      required: true,
      default: () => [],
      type: Array
    },
    fullwidth: {
      required: false,
      default: false,
      type: Boolean
    },
    defaultValue: {
      required: false,
      default: ['Alle typer'],
      type: Array
    },
    /**
     * If this is enabled, then the first item in the defaultValue prop is the select all option.
     */
    selectAllEnabled: {
        required: false,
        default: false,
        type: Boolean
    }
  },
  data() {
    return {
      currentItems: this.defaultValue,
      previousItems: this.defaultValue
    };
  },
  computed: {
    selectableItems() {
        return [this.defaultValue[0], ...this.items];
    },
  },
  methods: {
    changedValue(items) {
        if (this.selectAllEnabled) {
            const addedItem = this.currentItems.find(item => !this.previousItems.includes(item));
        
            // If the default value was clicked and other items are selected, reset to default value
            if (addedItem === this.defaultValue[0]) {
              this.currentItems = [this.defaultValue[0]];
            } 
            // If other items are clicked, remove the default value
            else if (this.currentItems.includes(this.defaultValue[0]) && this.currentItems.length > 1) {
              this.currentItems = this.currentItems.filter(item => item !== this.defaultValue[0]);
            }
        
            if (this.currentItems.length === 0) {
              this.currentItems = [this.defaultValue[0]];
            }
        
            this.previousItems = [...this.currentItems];
        }
        this.$emit('select-item', this.currentItems);
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-dropdown {
  &__selected {
    color: var(--v-primary-base);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
}
</style>